import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { BaseUiService } from 'projects/core/src/lib/services/base-ui.service';
import { TranslocoService } from '@ngneat/transloco';
import { Title } from '@angular/platform-browser';
import { AcModel } from '../models/ac.model';

@Injectable({
  providedIn: 'root'
})
export class UiService extends BaseUiService {

  protected focusSelector = '.p-tabview-panel:not([hidden]) .autofocus';
  protected focusInputSelector = '[role=main] form input:not([disabled])';

  constructor(
    protected messageService: MessageService,
    protected transloco: TranslocoService,
    protected confirmation: ConfirmationService,
    private router: Router,
    protected title: Title
  ) {
    super(messageService, transloco, confirmation, title);
  }

  public showRoutingInfo(header: string, message: string, target: Array<any>): void {
    this.confirmation.confirm({
      header,
      message,
      icon: 'pi pi-info-circle',
      acceptLabel: 'OK',
      accept: () => {
          this.router.navigate(target);
      },
      rejectVisible: false,
      closeOnEscape: false
    });
  }

  public showCopyrightInfo(): void {
    this.confirmation.confirm({
      message: this.transloco.translate('services.ui.copyright_message'),
      header: this.transloco.translate('services.ui.copyright_header'),
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      acceptLabel: this.transloco.translate('services.ui.copyright_button'),
      rejectVisible: false,
      accept: () => {
      }
    });
  }


  public showParticipantsChanged(ac: AcModel): void {
    this.confirmation.confirm({
      message: this.transloco.translate('services.ui.users_changed'),
      header: this.transloco.translate('common.labels.info'),
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      acceptLabel: this.transloco.translate('common.labels.ok'),
      rejectVisible: false,
      accept: () => {
        ac.setReload();
      }
    });
  }


  public copyToClipboard(value: string): void {
    navigator.clipboard.writeText(value).then(() => {
      this.toastSuccess(
        this.transloco.translate('dashboard.messages.copying_to_clipboard_successfull'),
        this.transloco.translate('dashboard.messages.success')
      );
    }, (err) => {
      this.toastSuccess(
        this.transloco.translate('dashboard.messages.copying_to_clipboard_did_not_work'),
        this.transloco.translate('dashboard.messages.error')
      );
    });
  }

}
